import React from 'react'
import{Link} from 'react-router-dom';

export default function EmptyCart() {
  return (
    <div className="container mt-5">
        <div className="row">
            <div className="col-10 mx-auto text-center text-title">
                <h1>Chưa có sản phẩm trong giỏ hàng của bạn.</h1>
                <Link className="btn btn-primary mt-2" to="/">TIẾP TỤC MUA HÀNG</Link>
            </div>
        </div>
    </div>
  )
}